import {
  DELETE_CHAT_NOTIFICATION,
  MARK_ALL_CHAT_NOTIFICATIONS_READ,
  MARK_CHAT_NOTIFICATION_READ,
  RESET,
  SET_ALL_CHAT_NOTIFICATIONS,
  SET_LAST_NOTIFICATION,
  SET_NOTIFICATION,
  SET_NOTIFICATION_TYPE,
} from "./notifications.actionTypes";

const initialState = {
  notification: null,
  notificationType: null,
  lastNotification: null,
  allChatNotifications: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION: {
      return {
        ...state,
        notification: action.payload,
      };
    }

    case SET_NOTIFICATION_TYPE: {
      return {
        ...state,
        notificationType: action.payload,
      };
    }

    case SET_LAST_NOTIFICATION: {
      return {
        ...state,
        lastNotification: action.payload,
      };
    }

    case SET_ALL_CHAT_NOTIFICATIONS: {
      return {
        ...state,
        allChatNotifications: action.payload,
      };
    }

    case MARK_CHAT_NOTIFICATION_READ: {
      return {
        ...state,
        allChatNotifications: state.allChatNotifications.map((item) =>
          item.id === action.payload ? { ...item, isRead: true } : item
        ),
      };
    }

    case MARK_ALL_CHAT_NOTIFICATIONS_READ: {
      return {
        ...state,
        allChatNotifications: state.allChatNotifications.map((item) => ({
          ...item,
          isRead: true,
        })),
      };
    }

    case DELETE_CHAT_NOTIFICATION: {
      return {
        ...state,
        allChatNotifications: state.allChatNotifications.filter(
          (item) => item.id !== action.payload
        ),
      };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
